export const brandFilterFields = ['name', 'code'];

export const brandSelectLabel = object => {
  return `${object.code} - ${object.name}`;
};

export const brandClusterOptions = [
  { label: 'Core', value: 'core' },
  { label: 'Image', value: 'image' },
  { label: 'Large', value: 'large' },
  { label: 'Tail', value: 'tail' },
];
